<template>
  <CCard
    class="auction-manager-card"
  >
    <CCardHeader>
        <div class="auction-manager-card__header">
          <CInput
            class="auction-manager-card__header-input"
            size="sm"
            placeholder="Search for auction...."
            :value="$route.query.search"
            @input="onInputSearch"
            @keyup.enter="onInputSearch($event.target.value)"
            @keyup.esc="onInputSearch()"
          />
        </div>
    </CCardHeader>
    <CCardBody
      color="white"
      border-color="white"
    >
      <CDataTable
        class="auction-manager__table marketplace-listing-table-container"
        :items="computedItems"
        :fields="fields"
        :loading="loading"
        @row-clicked="toggleRow"
        ref="table"
      >
        <template #rowId={item}>
          <td
            :data-row-id="item.id"
          ></td>
        </template> 

        <template #link="{item}">
          <td>
            <a
              :class="{ 'auction-manager__disabled-link': !item.link }"
              :href="item.link"
              target="blank"
            >
              Link
            </a>
          </td>
        </template>

        <template #edit={item}>
          <td>
            <CDropdown>
              <template #toggler>
                <CButton class="toggler">
                  <CIcon name="dots" />
                </CButton>
              </template>
              <!-- <CDropdownItem
                class="btn btn-info"
                @click="onSoldItem(item)"
              >
                Sold/NA
              </CDropdownItem>
              <CDropdownItem
                class="btn btn-info"
                @click="editItem(item)"
              >
                Edit
              </CDropdownItem> -->
              <CDropdownItem
                class="btn btn-info"
                @click="onViewItem(item)"
              >
                View
              </CDropdownItem>
              <CDropdownItem
                class="btn btn-info"
                @click="onRawViewItem(item)"
              >
                Raw View
              </CDropdownItem>
            </CDropdown>
          </td>
        </template>
        
        <template #username="{item}">
          <td class="username">
            <a :href="getUserLink(item.username)" target="_blank">{{item.username}}</a>
          </td>
        </template>
        
        <template #display_name="{item}">
          <td class="auction-verified">
            {{item.display_name}}
          </td>
        </template>
        
      </CDataTable>
    </CCardBody>
    <CCardFooter class="auction-manager-card__footer">
      <VTeslaAuctionManagerPagination
        class="auction-manager-card__footer-pagination"
        :current-page.sync="currentPage"
      />
    </CCardFooter>
  </CCard>
</template>
<script>
import { auctionManagerStore, createAuctionManagerMixin } from '@/mixins/auctionsManagerMixin'
import VTeslaAuctionManagerPagination from '@/components/AuctionManager/VTeslaAuctionManagerPagination'
import { toggleRowClass } from '@/utils/table/toggleRowClass'
import { debounce } from '@/utils/debounce'
import ModalType from '@/utils/dictionaries/modalType'
import { getLastCarBid, getStatus, getStatusColor, isReversePriceNotMeet, isZeroBids, isEndedCar } from '@/utils/validation/car'
import { CAR_STATUS } from '@/utils/dictionaries/car'
import getTimerFromNowToDate from '@/utils/time/getTimerFromNowToDate'
import { getUserLink } from '@/utils/validation/user'
import URLS from '@/constants/url'
import api from "@/api/api";
import moment from "moment"
import {
  createCarManagerMixin,
  carManagerStore
} from "@/mixins/carManagerMixin";
import { encodeToBase62 } from '@/utils/slug'
const defaultImage = 'https://media.carsandbids.com/cdn-cgi/image/width=712,height=468,quality=70/da4b9237bacccdf19c0760cab7aec4a8359010b0/photos/3ja0R3IXGI2-2.lmFYrFQis.jpg?t=160323755351'

export default {
  name: 'TeslaVehicleList',

  components: {
    VTeslaAuctionManagerPagination,
},

  mixins: [
    createAuctionManagerMixin(),
    createCarManagerMixin()
  ],

  data () {
    return {
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'username', label: 'Username' },
        { key: 'display_name', label: 'Display Name', _classes: 'username', _style: 'min-width: 125px;max-width: 125px' },
        { key: 'color', label: 'Color', _classes: 'username', _style: 'min-width: 125px;max-width: 125px' },
        { key: 'vin', label: 'Vin', _classes: 'username', _style: 'min-width: 125px;max-width: 125px' },
        { key: 'state', label: 'State', _classes: 'username', _style: 'min-width: 125px;max-width: 125px' },
        { key: 'access_type', label: 'Access Type', _classes: 'username', _style: 'min-width: 125px;max-width: 125px' },
        { key: 'vehicle_id', label: 'Tesla Vehicle ID', _classes: 'username', _style: 'min-width: 125px;max-width: 125px' },
        // { key: 'link', label: 'Link', _classes: 'username', _style: 'min-width: 125px;max-width: 125px' },
        { key: 'createdAt', label: 'Date Added', _classes: 'username', _style: 'min-width: 200px;max-width: 200px' },
        { key: 'edit', label: 'Edit', _style: 'min-width: 125px;max-width: 62px' },

       
      ],
      checkedRows: [],
      currentPage: 1,
      loading: false,
      searchFn: () => {},
      getUserLink: getUserLink
    }
  },

  async created () {
    await this.loadData()

    this.searchFn = debounce.call(this, async (term) => {
      const query = {
        ...this.$route.query,
        search: term
      }

      if (!query.search && query.skip) {
        query.skip = 0
      }

      this.$router.push({
        query
      }).catch(() => {})
    }, 200)
  },

  watch: {
    isReload(newValue){
      this.loadData();
    },
    checkedRows (rows) {
      this.checkRows(rows, 'auction-manager__row-checked')
    },
    computedItems() {
      this.checkRestartRows()
    },
    $route () {
      this.clearCheckboxes()
      this.loadData()
    }
  },

  computed: {
    isReload() {
      return this[auctionManagerStore.getterTypes.GETTER_PAGE_RELOAD];
    },
    auctions () {
      return this[auctionManagerStore.getterTypes.GETTER_TESLA_AUCTIONS]
    },
    auctionsCount () {
      return this[auctionManagerStore.getterTypes.GETTER_TESLA_AUCTIONS_COUNT]
    },
    
    computedItems () {
      console.log("this.auctions",this.auctions)
      return this.auctions && this.auctions.map(a => {
        const item  = {
          id: a.id,
          access_type: a.access_type,
          vin: a.vin,
          api_version: a.api_version,
          backseat_token: a.backseat_token,
          backseat_token_updated_at: a.backseat_token_updated_at,
          ble_autopair_enrolled: a.ble_autopair_enrolled,
          calendar_enabled: a.calendar_enabled,
          color: a.color,
          display_name: a.display_name,
          option_codes: a.option_codes,
          share_type_s: a.share_type_s,
          state: a.state,
          user: a.userId,
          username: a.userId.username,
          vehicle_id: a.vehicle_id,
          createdAt: moment(a.createdAt).format("lll"),
          link: this.getLink(a),        
        }
        // this.checkCarTimer(item) TODO: Make status value from awaiting to In progress
        return item
      })
    },
    checkedRowsCount () {
      return this.checkedRows.length
    },
    isChecked () {
      return this.checkedRows
        .map(row => row.id)
        .reduce((acc, val) => {
          acc[val] = true
          return acc
        }, {})
    }
  },

  methods: {
    async onTaxCreditChange(event){
      // try {
      //   this.loading = true
      //   const formData = new FormData()
      //   formData.append("taxCredit",event.target.value)
      //   await this[marketplaceStore.actionTypes.ACTION_UPDATE_MARKETPLACE_CAR]({ carId: event.target.id, formData: formData})
      //   this.loadData()
      // } catch (error) {
      //   console.log("error in change type", error)      
      // }
      console.log("onTaxCreditChange value", event.target.value)
      console.log("onTaxCreditChange id", event.target.id)
    },
    onSoldItem(item) {
      const soldAction = async () => {
        try {
          await api.put(`/statistical/car-sold/${item.id}`);
          this.$modals.close(ModalType.ConfirmationModal);
          this.$router.go();
        } catch (error) {
          console.log(error);
        }
      };

      this.$modals.open(ModalType.ConfirmationModal, {
        title: "Sold",
        body: `Are you sure this car has been sold?`,
        buttonText: "Sold",
        onClickButton: soldAction
      });
    },
    
    onDeleteItem(item) {
      const deleteAction = async () => {
        try {
          await api.delete(`/cars/${item.id}`);
          this.$modals.close(ModalType.ConfirmationModal);
          this.$router.go();
        } catch (error) {
          console.log(error);
        }
      };

      this.$modals.open(ModalType.ConfirmationModal, {
        title: "Deletion",
        body: `Are you sure you want to delete this car?`,
        buttonText: "Delete",
        onClickButton: deleteAction
      });
    },
    openComments(item){
      const { comments, ...itemWithoutComments } = item;
        return this.$modals.open(ModalType.CommentsModal, {
          ...itemWithoutComments,
          disabled: false
        });    
    },
    findImage(carImages){
        if(carImages.length > 0){
          let url = ""
          url = carImages.find(c => c.mainImage === 1 )?.url;
          if(!url){
            url = carImages.find(c => c.illustratorId === 1 )?.url;
          }
          if(!url){
            url = defaultImage
          }
          return url
        }
        return 
      },
      onViewItem (item) {
      console.log("edit item")
      let auction = this.auctions.find(a => a.id === item.id)
      auction['viewType'] = "view"

      this.$modals.open(ModalType.ViewTeslaVehicle, { ...auction})
    },
    onRawViewItem (item) {
      console.log("onRawViewItem item")
      let auction = this.auctions.find(a => a.id === item.id)
      auction['viewType'] = "raw"
      this.$modals.open(ModalType.ViewTeslaVehicle, { ...auction})
    },
    editItem (item) {
      console.log("edit item")
      const auction = this.auctions.find(a => a.id === item.id)
      const disabled = isEndedCar(auction) && !this.canRestart(auction)
      this.$modals.open(ModalType.EditAuctionModal, { ...auction, disabled: disabled})
    },
    clearCheckboxes () {
      this.checkedRows = []
      this.canRestartRows = []
    },
    checkRestartRows() {
      const canRestartRows = this.auctions.filter(a => this.canRestart(a))
      this.checkRows(canRestartRows, 'auction-manager__row-restart')
    },
    getStatus (auction) {
      return getStatus(auction)
    },
    getColor (status) {
      return getStatusColor(status)
    },
    getLastBid (auction) {
      return getLastCarBid(auction)
    },
    getLink (auction) {
      return `${URLS.app}/tesla/vehicle/${auction.vin}`
    },
    toggleAll () {
      if (this.checkedRows.length) {
        this.checkedRows = []
      } else {
        this.checkedRows = [...this.computedItems]
      }
    },
    toggleRow(item, index, columName, event) {
      console.log("toggleRow")
      if (this.checkedRows && this.checkedRows.includes(item) && event.path && event.path.some(el => el?.classList?.contains('toggler'))) return

      if (this.isChecked[item.id]) {
        this.checkedRows = []
      } else {
        this.checkedRows = [item]
      }
    },
    checkCarTimer(item) {
      const changeStatus = (time, timerId, status, restartCheck = false) => {
        if (time >= 0) {
          clearTimeout(timerId)
          item.status = status
          if (restartCheck) {
            this.checkCarTimer(item)
          }
        }
      }
      if (item.status === CAR_STATUS.Awaiting) {
        getTimerFromNowToDate(item.startDate, (time, timerId) => 
          changeStatus(time, timerId, CAR_STATUS.Progress, true))
      } else {
        getTimerFromNowToDate(item.endDate, (time, timerId) => 
          changeStatus(time, timerId, CAR_STATUS.Ended))
      }
    },
    async loadData () {
      this.loading = true
      await this[auctionManagerStore.actionTypes.ACTION_LOAD_TESLA_VEHICLES]({
        take: this.$route.query.take || 10,
        skip: this.$route.query.skip || 0,
        search: this.$route.query.search,
        all: true
      })
      this.loading = false

      this.checkRestartRows()
    },
    onInputSearch (value) {
      this.searchFn(value)
    },
    canRestart(auction) {
      return isEndedCar(auction) && (isReversePriceNotMeet(auction) || isZeroBids(auction))
    },
    checkRows(rows, rowClass) {
      if (!this.$refs.table) return
      const rowsSelector = rows.reduce((acc, item) => `[data-row-id="${item.id}"],` + acc, '').replace(/,$/, '')
      const rowsEl = rowsSelector.length > 0 ? this.$refs.table.$el.querySelectorAll(rowsSelector) : []

      const allRowsSelector = this.computedItems.reduce((acc, item) => `[data-row-id="${item.id}"],` + acc, '').replace(/,$/, '')
      const allRowsEl = allRowsSelector.length > 0 ? this.$refs.table.$el.querySelectorAll(allRowsSelector) : []

      Array.from(allRowsEl).forEach(row => {
        if (row.parentNode.nodeName === 'TR') {
          toggleRowClass(row.parentNode, rowClass, false)
        }
      })

      Array.from(rowsEl).forEach(row => {
        if (row.parentNode.nodeName === 'TR') {
          toggleRowClass(row.parentNode, rowClass)
        }
      })

    },
    onChangeCheckBoxInput($event){
      console.log("onChangeCheckBoxInput", $event.target.id)
      this[auctionManagerStore.actionTypes.ACTION_CAR_FEATURED]({ id: Number($event.target.id), featured: $event.target.checked, route: this.$route })
      // alert("test", $event?.target?.checked)
    },
    onChangeTestCheckBoxInput($event){
      console.log("onChangeCheckBoxInput", $event.target.id)
      this[carManagerStore.actionTypes.ACTION_TEST_MODE_CAR]({ id:  Number($event.target.id), isTestMode:  $event.target.checked })
      // alert("test", $event?.target?.checked)
    }
  }
}
</script>
